import EventDetailCard from '@ulta/components/EventDetailCard/EventDetailCard';

export default EventDetailCard;